import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaFazendaSefazCepRequest } from './types';

// ACTIONS
import {
	consultaFazendaCpfCepSefazSuccess,
	consultaFazendaCpfCepSefazFailure,
} from './actions';

function* consultaFazendaCpfCepSefazSaga(request: ReducerAction) {
	const { payload }: { payload: ConsultaFazendaSefazCepRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`/fazenda/${CHANNEL}/valida-cep-cpf`,
		payload,
	);

	if (response.status === 200) {
		yield put(consultaFazendaCpfCepSefazSuccess(response));
	} else if (response.error) {
		yield put(consultaFazendaCpfCepSefazFailure(response.error));
	}
}

export default all([
	takeLatest(
		Types.CONSULTA_FAZENDA_CPF_CEP_SEFAZ,
		consultaFazendaCpfCepSefazSaga,
	),
]);
